import { jsx as _jsx } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/components/Home.tsx
import React from 'react';
var About = function () {
    return (_jsx("div", { children: _jsx("h1", { children: "About Page" }) }));
};
export default About;
